var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M5.78 3.003c.161-.136.405-.232.684-.232zM4.634 1.655A2.83 2.83 0 0 1 6.464 1h10.672c.664 0 1.325.223 1.832.655l-.575.674.575-.674c.51.434.832 1.058.832 1.744v18.167a.886.886 0 0 1-1.46.674l-6.54-5.567-6.54 5.567a.886.886 0 0 1-1.46-.674V3.399c0-.686.322-1.31.833-1.744M6.464 2.77h10.672zm10.672 0c.279 0 .523.096.683.232zM5.78 3.003c-.157.133-.21.28-.21.396v16.25l5.655-4.813a.886.886 0 0 1 1.148 0l5.655 4.813V3.399c0-.116-.053-.263-.21-.396",
  clipRule: "evenodd"
})));
export default SvgBookmark;